<!--suppress ALL -->
<!--suppress UnreachableCodeJS -->
<template>
	<c-card color="#82b1ff">
		<h4 slot="title"><v-icon>mdi-office-building</v-icon> {{$t('pages.apartmentForm.apartment')}}</h4>
		<v-btn icon slot="bar-actions" @click="$emit('remove',apartment)">
			<v-icon>delete</v-icon>
		</v-btn>
		<cols-row md="3">
			<smart-input :error="inputErrors.building" :label="$t('pages.orderForm.building')" v-model="apartment.building"></smart-input>
			<smart-input :error="inputErrors.entrance" :label="$t('pages.orderForm.entrance')" v-model="apartment.entrance"></smart-input>
			<smart-input :error="inputErrors.apartment_num" required :label="$t('pages.orderForm.apartmentNum')" v-model="apartment.apartment_num"></smart-input>
			<smart-input :error="inputErrors.apartment_floor" required :label="$t('pages.orderForm.floor')" v-model="apartment.apartment_floor"></smart-input>
		</cols-row>
		<cols-row md="3">
			<smart-input :error="inputErrors.designer" required :label="$t('pages.orderTable.designer')" v-model="apartment.designer"></smart-input>
			<smart-input type="tel" :error="inputErrors.designer_phone" :pattern="phonePattern" :label="$t('pages.orderTable.designerPhone')" v-model="apartment.designer_phone"></smart-input>
			<smart-input :error="inputErrors.customer" :label="$t('pages.apartmentForm.tenantName')" required v-model="apartment.customer"></smart-input>
			<smart-input :error="inputErrors.order_num" :label="$t('pages.orderTable.orderNum')" required v-model="apartment.order_num"></smart-input>

			<recheck-select v-model="apartment.recheck" v-cant="['client']"></recheck-select>

		</cols-row>

		<measurement-form @remove="removeMeasurement(m)" :removedFiles="removedFiles" :measurement="m" v-for="m in measurementsWithFiles" :key="m.id"/>
		<cols-row md="3">
			<v-btn color="blue"  @click="addMeasurement">
				<v-icon left>add</v-icon>
				<v-icon>mdi-ruler</v-icon>
				{{$t('pages.orderForm.anotherOrder')}}
			</v-btn>
		</cols-row>
	</c-card>
</template>


<script>
	import CCard from "dev/scaffoldings/cCard";
	import MeasurementForm from "dev/view/measurements/MeasurementForm";
	import {uniqueId} from "lodash";
	import RecheckSelect from "dev/view/orders/RecheckSelect";

	export default {
		props: {
			inputErrors: {
				default: () => {
					return {};
				},
			},
			apartment: Object,
			currentMeasurement: Object,
			removedFiles: Array,
		},
		name: "apartment-form",
		components: {RecheckSelect, MeasurementForm, CCard},
		data() {
			return {
        phonePattern: "^[0-9]{2,3}-[0-9]{7}",

      };
		},
		computed: {
			measurementsToShow() {
				if (this.currentMeasurement) {
					return this.apartment.measurements.filter((m) => {
						return m.id == this.currentMeasurement.id ||
							(isNaN(m.id) && m.id.indexOf("notreal") == 0);
					});
				}
				return this.apartment.measurements;
			},
			measurementsWithFiles() {
				let measurementsToShow = this.measurementsToShow;
				measurementsToShow.forEach((item)=>{
					if(this.currentMeasurement){
						item.files = this.currentMeasurement.files;
					}
					item.removedFiles = [];
				});
				return measurementsToShow;
			}
		},

		methods: {
			removeMeasurement(m) {
				let index = this.apartment.measurements.indexOf(m);
				if (index > -1) {
					this.apartment.measurements.splice(index, 1);
				}
			},
			addMeasurement() {
				this.apartment.measurements.push({
					id: uniqueId("notreal"),
					files:[]
				});
			}
		}
	};
</script>

<style>

</style>
